import React, { useContext, useEffect } from 'react'
import { Transition, TransitionGroup } from 'react-transition-group'
import GlobalStyle from 'styles/global-styles'
import { LayoutWrapper, PageWrapper, ContentWrapper } from './index.styled'
import { LanguageContext } from 'context/locale-context'
import 'styles/fonts.css'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const LayoutContent = ({ children, location }) => {
  return (
    <TransitionGroup component={null}>
      <Transition key={location.pathname} timeout={{ enter: 1000, exit: 0 }}>
        {(status) => (
          <div className={`page ${status}`}>
            <LayoutWrapper id='layoutWrapper'>{children}</LayoutWrapper>
          </div>
        )}
      </Transition>
    </TransitionGroup>
  )
}

const Layout = ({ children, location, pageContext }) => {
  const { language } = useContext(LanguageContext)

  useEffect(() => {
    ScrollTrigger.refresh()
  }, [location])

  return (
    <>
      <PageWrapper>
        <GlobalStyle />
        <ContentWrapper>
          <LayoutContent location={location} language={pageContext[language]}>{children}</LayoutContent>
        </ContentWrapper>
      </PageWrapper>
    </>
  )
}

export default Layout
